import { Injectable } from "@angular/core";
import { RecipeBoDtoNBK, RecipeService } from "src/app/api/nbk";
import { getMultipleExportOptions, haveAllSameDeviceModel } from "src/app/core/recipe.utils";
import { OptionsModalState } from "../../modals/options-modal/options-modal.component";
import { DeviceModelEnum, getFileNameFromHttpHeader, KEY_LANGUAGE_STORAGE } from "src/app/core/utils";
import { HttpResponse } from '@angular/common/http';
import { take } from "rxjs";
import { ModalService } from "../../modals/modal.service";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";


@Injectable({ providedIn: 'root' })
export class ExportMultipleRecipesHandler {

  constructor(    
    private modalService: ModalService,
    private toastrService: ToastrService,
    private ts: TranslateService,
    private recipeService: RecipeService,
  ) {}

  exportSelectedRecipes( recipes: { id?: number; deviceModel?: DeviceModelEnum }[], onSuccess: () => void ) {
    const sameDeviceModel = haveAllSameDeviceModel(recipes);
    if ( sameDeviceModel ) {
      this.exportMultiples( recipes.map( r => r.id!), onSuccess );
    } else {
      const modalInfo: OptionsModalState = {
        title: this.ts.instant('GLOBAL.EXPORT'),
        message: this.ts.instant('RECIPES.EXPORT.HINT'),
        options: getMultipleExportOptions( recipes ),
        preventClose: true
      };
  
      this.modalService.showOptionsModal(modalInfo).subscribe((s : any) => {
        const toExport = Array.from( recipes )
          .filter( r => r.deviceModel === s as RecipeBoDtoNBK.DeviceModelEnum).map( r => r.id! );
        this.exportMultiples(toExport, onSuccess);
      });
    }
  }

  private exportMultiples(toExport: number[], onSuccess: () => void) {
    this.recipeService
      .exportRecipes(localStorage.getItem(KEY_LANGUAGE_STORAGE)!, {
        ids: toExport,
      }, "response")
      .pipe(take(1))
      .subscribe((data: HttpResponse<any>) => {
        this.onDownloadSuccess(data);
        onSuccess();
      });
  }

  public onDownloadSuccess(data: HttpResponse<any>) {
    const fileName = getFileNameFromHttpHeader(data);
    this.toastrService.success(
      this.ts.instant('RECIPE.EXPORTED'),
      this.ts.instant('GLOBAL.SUCCESS')
    );
    const url = window.URL.createObjectURL(data.body);
    var fileLink = document.createElement('a');
    fileLink.href = url;
    fileLink.download = fileName;
    fileLink.click();
  }

}
